export const Events = {
    Enable: 'skapa-focus-lock-enable',
    Disable: 'skapa-focus-lock-disable',
    Escape: 'skapa-focus-lock-escape-hotkey',
};
export class SkapaFocusLockEvent extends Event {
    constructor(type, ref) {
        super(type);
        this.SkapaFocusLockReference = ref;
    }
}
